import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import ChalkyLayout from "components/chalky-layout"
import memo from "set-state-compare/build/memo"
import React from "react"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

export default memo(shapeComponent(class RoutesUserUnsubscribed extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.user.unsubscribed"})

    this.t = t
  }

  render() {
    const {t} = this.tt

    return (
      <ChalkyLayout dataSet={this.chalkyLayoutDataSet ||= {route: "unsubscribed"}} requireUser={false}>
        {t(".you_have_been_unsubscribed")}
      </ChalkyLayout>
    )
  }
}))
